import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { alertActions } from "../../../_actions/alert.actions";
import { useTranslation } from "react-i18next";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import "../CustomAlert/customAlert.scss";
import { useNavigate } from "react-router-dom";

function CustomAlert() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { alert } = useSelector((state) => state.alert);
  const navigate=useNavigate();

  const handleClose = (event) => {
    event.preventDefault();
    dispatch(alertActions.removeAlert());
    navigate("/login");
  };

  return alert ? (
    <OverlayContainer>
      <div className="alert-dialog-inner">
        <div className="alert-dialog-close" onClick={handleClose}>
          <div>
            <i className="icon check"></i>
          </div>
        </div>
        <div className="alert-title">{t(alert.title)}</div>
        <div className="alert-message">{t(alert.message)}</div>

        <div className="alert-close-btn">
          <a href="/login" onClick={handleClose}>
            Close
          </a>
        </div>
      </div>
    </OverlayContainer>
  ) : null;
}

export default CustomAlert;
